export default __webpack_public_path__ + "images/arrow_left-a7d98ef48af48331f0766a1f53f4dbc6.png";